import React, { useState, useEffect } from "react";
import Navbar from "../Navbar/Navbar";
import Table from "../Table/Table";
import Table_Buttons from "../Table_Button/Table_button";
import { toast } from "react-toastify";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";
import Spinner from "../Spinner/Spinner";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
function TeamReward_income() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [spinner, setSpinner] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [currentPage, setcurrentPage] = useState(1);
  const [listPerpage, setlistPerpage] = useState(10);
  const [leftreferralApi, setleftreferralApi] = useState([]);
  const [search, setSearch] = useState("");
  const [todate, setTodate] = useState("");
  const [formdate, setFromdate] = useState("");

  const [TotalAmount, setTotalAmount] = useState(0);

  const referral_API = async () => {
    setisLoading(true);
    try {
      let responceRight = await API?.post(
        "/Adminreport",
        {
          loginid: userId,
          uid: search.slice(2),
          fdate: formdate,
          tdate: todate,
          report: "user_reward",
          status: "2",
          level: "0",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("My_Team", responceRight);
      setTotalAmount(responceRight?.data?.data[0][0].TotalAmount);
      responceRight = responceRight?.data?.data[0];

      setleftreferralApi([]);
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          uid: `AC${item.uid}`,
          lvl: item.lvl,
          f_name: item.f_name,
          chargeamount: item.chargeamount,
          Netpay: item.Netpay,
          holder: item.holder,
          accountnumber: item.accountnumber,
          ifsc: item.ifsc,
          bank_name: item.bank_name,
          rank: item.rank,
          reqleg1: `$ ${item.reqleg1}`,
          leg1: `$ ${item.leg1}`,
          reqleg2: `$ ${item.reqleg2}`,
          leg2: `$ ${item.leg2}`,
          reward: item.reward,
          status: item.status,
          remark: item.remark,
          achievedstatus:
            item.achievedstatus == "Qualified" ? (
              <span className="text-success"> {item.achievedstatus}</span>
            ) : (
              <span className="text-danger">{item.achievedstatus}</span>
            ),
          Paidstatus: item.Paidstatus,
          achieved_date: item.achieved_date,
          paid_date: item.paid_date,
          paid:
            item.paid === 0 ? (
              <button
                className="btn btn-info btn-lg"
                style={{ width: "70px", borderRadius: "13px" }}
                onClick={() => PayReward(item.id, item.uid)}
              >
                Pay
              </button>
            ) : (
              "Paid"
            ),
        });
        setleftreferralApi(arrayLeft);
      });
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    } finally {
      setisLoading(false);
    }
  };

  const PayReward = async (RowId, Uid) => {
    try {
      console.log("fdfdf", RowId, Uid);
      setSpinner(true);
      let res = await API.post(
        "/PaidUserBonusReward",
        {
          loginid: userId,
          uid: Uid,
          id: RowId,
          status: "1",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("approve_api", res.data.data);
      toast.success(res.data.data);
      referral_API();
    } catch (error) {
      console.log("API ERROR", error);
      setSpinner(false);
    }
  };

  useEffect(() => {
    referral_API();
  }, []);

  const referral_API_Export = async () => {
    try {
      let responceRight = await API?.post(
        "/Adminreport",
        {
          loginid: userId,
          uid: search.slice(2),
          fdate: formdate,
          tdate: todate,
          report: "user_reward",
          status: "2",
          level: "0",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("ActiveMemberList_New-->", responceRight.data.data[0]);
      responceRight = responceRight.data.data[0];
      let arrayLeft = [];
      responceRight.forEach((item, index) => {
        arrayLeft.push({
          sr: index + 1,
          uid: `AC${item.uid}`,
          Name: item.f_name,
          rank: item.rank,
          reward: item.reward,
          chargeamount: item.chargeamount,
          Netpay: item.Netpay,
          holder: item.holder,
          accountnumber: item.accountnumber,
          ifsc: item.ifsc,
          bank_name: item.bank_name,
          DateandTime: item.achieved_date,
          Paidstatus: item.Paidstatus,
          paid_date: item.paid_date,
        });
      });

      const fileName = "LeadershipPerformanceBonus";
      const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      const fileExtension = ".xlsx";
      const ws = XLSX.utils.json_to_sheet(arrayLeft);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = XLSX.write(wb, {
        bookType: "xlsx",
        type: "array",
      });
      const data = new Blob([excelBuffer], { type: fileType });
      FileSaver.saveAs(data, fileName + fileExtension);
    } catch (e) {
      console.log("Error While calling Myteam API", e);
    }
  };
  const indexOfLastPost = currentPage * listPerpage;
  const indexOfFirstPage = indexOfLastPost - listPerpage;
  const currentPostleft = leftreferralApi.slice(
    indexOfFirstPage,
    indexOfLastPost,
  );

  var [my_team, set_my_team] = useState({
    cols: [
      { Header: "S.No", accessor: "sr" },
      { Header: "User ID", accessor: "uid" },
      { Header: "User Name", accessor: "f_name" },
      // { Header: "Rank", accessor: "lvl" },
      { Header: "Rank ", accessor: "rank" },
      { Header: "Reward", accessor: "reward" },
      { Header: "Admin Charge", accessor: "chargeamount" },
      { Header: "Net Payable", accessor: "Netpay" },
      { Header: "A/c Holder", accessor: "holder" },
      { Header: "A/c No.", accessor: "accountnumber" },
      { Header: "IFSC", accessor: "ifsc" },
      { Header: "Bank Name", accessor: "bank_name" },
      { Header: "Date & Time", accessor: "achieved_date" },
      { Header: "Paid Status", accessor: "Paidstatus" },
      { Header: "Paid Date", accessor: "paid_date" },
      { Header: "Paid", accessor: "paid" },
    ],
  });

  return (
    <div>
      <Navbar />
      <div class="content-page">
        <div class="content">
          <div class="row">
            <div class="col-md-12">
              <div class="panel panel-primary">
                <div class="panel-heading">
                  <h4 class="panel-title">Leadership Performance Bonus</h4>
                </div>
                <div class="panel-body">
                  <div class="row">
                    <div class="col-md-2">
                      <input
                        type="text"
                        id="txtuid"
                        ng-model="p.uid"
                        onChange={(e) => setSearch(e.target.value)}
                        class="form-control ng-pristine ng-untouched ng-valid ng-empty ng-valid-maxlength"
                        placeholder="Enter User Id"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setFromdate(new Date(e.target.value))}
                        id="fdate"
                        name="fdate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        class="form-control in-ip-1"
                        onChange={(e) => setTodate(e.target.value)}
                        id="todate"
                        name="todate"
                        type="date"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="button"
                        id="btnsearch"
                        onClick={() => {
                          referral_API();
                        }}
                        class="btn btn-sm btn-primary"
                        value="Search"
                      />
                    </div>
                    <div class="col-md-2">
                      <input
                        type="reset"
                        id="btnsearch"
                        formmethod="get"
                        onClick={() => referral_API_Export()}
                        class="btn btn-lg btn-primary"
                        value="Export to Excel"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <h4>
                      <span>Total Income: {TotalAmount}</span>
                    </h4>

                    {isLoading ? (
                      <Spinner />
                    ) : (
                      <div className="col-md-12">
                        <Table data={currentPostleft} columns={my_team.cols} />

                        <Table_Buttons
                          indexOfFirstPage={indexOfFirstPage}
                          indexOfLastPost={indexOfLastPost}
                          setcurrentPage={setcurrentPage}
                          currentPage={currentPage}
                          totalData={leftreferralApi.length}
                          listPerpage={listPerpage}
                          handleRowsPerPageChange={setlistPerpage}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamReward_income;
